export default function contactModal() {
    return import(/* webpackChunkName: "contactModal" */
    './index').then(mod => {
        return mod.default;
    });
}



// WEBPACK FOOTER //
// ./src/contactModal/async.js